import styled, { css } from 'styled-components';
import { PlaceholderShimmerBackground } from 'utils/fragments';
import Stack from './Stack';

const HoverStyles = css`
    &:hover,
    &:focus-visible {
        color: ${({ theme }) => theme.purple_1};
        border-color: ${({ theme }) => theme.purple_4};
    }

    &:hover > *,
    &:focus-visible > * {
        color: ${({ theme }) => theme.purple_1};
    }
`;

const TileFragment = css`
    flex-grow: 1;
    background-color: ${({ theme, isLoading }) =>
        isLoading ? theme.gray_5 : theme.gray_7};
    color: ${({ theme }) => theme.gray_2};
    border: 1px solid ${({ theme }) => theme.gray_5};
    border-radius: ${({ theme }) => theme.borderRadius_lg};
    display: inline-flex;
    flex-direction: column;
    align-items: stretch;
    padding: ${({ theme }) => theme.space_7}px;
    font-family: ${({ theme }) => theme.style_primary};
    text-align: left;
    text-transform: capitalize;
    text-decoration: none;
    opacity: ${({ isDisabled, isLoading }) =>
        isDisabled && !isLoading ? 0.5 : 1};

    ${({ isDisabled, isInteractive }) => {
        if (isDisabled || isInteractive === false) return;
        return HoverStyles;
    }}
    ${({ isLoading }) => isLoading && PlaceholderShimmerBackground}
`;

const Tile = styled(Stack).attrs(
    ({ $space = (theme) => `${theme.space_5}px` }) => ({
        $space,
    }),
)`
    ${TileFragment}
`;
Tile.Fragment = TileFragment;

export default Tile;
